import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "CampaignEditorRightColumn" }
const _hoisted_2 = { class: "CampaignEditorCheckboxLabel" }
const _hoisted_3 = ["checked", "disabled"]
const _hoisted_4 = {
  key: 0,
  class: "CampaignEditorCheckboxLabel"
}
const _hoisted_5 = ["checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!

  return (_openBlock(), _createBlock(_component_LoadingWrapper, {
    classes: ['CampaignEditorRow'],
    isLoading: _ctx.isLoading
  }, {
    default: _withCtx(() => [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "CampaignEditorLeftColumn" }, [
        _createElementVNode("label", { class: "CampaignEditorInputLabel" }, " Other ")
      ], -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, [
          _createElementVNode("input", {
            type: "checkbox",
            checked: _ctx.campaignLiftExcluded,
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setCampaignLiftExcludedBasedOnEvent && _ctx.setCampaignLiftExcludedBasedOnEvent(...args))),
            disabled: _ctx.campaignLiftExclusionNotAllowedForPartnershipType || _ctx.userIsNotAllowedToEditCampaignExclusion
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3),
          _cache[2] || (_cache[2] = _createTextVNode(" Campaign Lift Excluded ", -1 /* CACHED */))
        ]),
        (!_ctx.isCampaignTypeCustomProductsOnly)
          ? (_openBlock(), _createElementBlock("label", _hoisted_4, [
              _createElementVNode("input", {
                type: "checkbox",
                checked: _ctx.persistGLParamRefLink,
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setPersistGLParamRefLinkBasedOnEvent && _ctx.setPersistGLParamRefLinkBasedOnEvent(...args)))
              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_5),
              _cache[3] || (_cache[3] = _createTextVNode(" Persist Google Linker Parameter into Referral Link ", -1 /* CACHED */))
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["isLoading"]))
}